module.exports = __webpack_public_path__ + "static/media/GCE_accuracy-min.abd684bf.jpg";